import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class FixedTpuDetail extends Component {
  state = {
    pageTitle: "TPU Sabitleri Detay",
    pageTitleDetail: "TPU Sabitleri Detay",
    pageAddLink: "tpu-sabitleri-ekle",
    pageListLink: "tpu-sabitleri-listele",
    breadcrumb: [{ text: "TPU Sabitleri", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    name: "",
    lama810Rate: 0,
    profitRate: 0,
    transportRate: 0,
    raw1Rate: 0,
    raw2Rate: 0,
    raw3Rate: 0,
    raw4Rate: 0,
    raw5Rate: 0,
    raw6Rate: 0,
    raw7Rate: 0,
    raw8Rate: 0,
    bigCostRate: 0,
    bigProductionRate: 0,
    smallCostRate: 0,
    smallProductionRate: 0,
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/fixedTpus/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            lama810Rate: parseFloat(response.data.lama810Rate),
            profitRate: parseFloat(response.data.profitRate),
            transportTotal: parseFloat(response.data.transportTotal),
            raw1Rate: parseFloat(response.data.raw1Rate),
            raw2Rate: parseFloat(response.data.raw2Rate),
            raw3Rate: parseFloat(response.data.raw3Rate),
            raw4Rate: parseFloat(response.data.raw4Rate),
            raw5Rate: parseFloat(response.data.raw5Rate),
            raw6Rate: parseFloat(response.data.raw6Rate),
            raw7Rate: parseFloat(response.data.raw7Rate),
            raw8Rate: parseFloat(response.data.raw8Rate),         
            smallProductionRate: parseFloat(response.data.smallProductionRate),         
            bigProductionRate: parseFloat(response.data.bigProductionRate),          
            smallCostRate: parseFloat(response.data.smallCostRate),          
            bigCostRate: parseFloat(response.data.bigCostRate),           
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>

                <tr>
                    <th>Hammadde-1 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw1Rate ? this.state.raw1Rate : "-"}
                    </td>                
                  </tr>

                  <tr>
                    <th>Hammadde-2 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw2Rate ? this.state.raw2Rate : "-"}
                    </td>                 
                  </tr>
                 
                 
                  <tr>
                    <th>Hammadde-3 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw3Rate ? this.state.raw3Rate : "-"}
                    </td>                
                  </tr>

                  <tr>
                    <th>Hammadde-4 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw4Rate ? this.state.raw4Rate : "-"}
                    </td>
                  
                  </tr>

                  <tr>
                    <th>Hammadde-5 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw5Rate ? this.state.raw5Rate : "-"}
                    </td>
                  
                  </tr>

                  <tr>
                    <th>Hammadde-6 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw6Rate ? this.state.raw6Rate : "-"}
                    </td>
                   
                  </tr>

                  
                  <tr>
                    <th>Hammadde-7 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw7Rate ? this.state.raw7Rate : "-"}
                    </td>
                    
                  </tr>

                  <tr>
                    <th>Hammadde-8 Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.raw8Rate ? this.state.raw8Rate : "-"}
                    </td>
                   
                  </tr>
                  <tr>
                    <th>Küçük Enj Üretim Miktarı Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.smallProductionRate ? this.state.smallProductionRate : "-"}
                    </td>
  
                  </tr>

                  <tr>
                    <th>Büyük Enj Üretim Miktarı Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.bigProductionRate ? this.state.bigProductionRate : "-"}
                    </td>
                  
                  </tr>

                  <tr>
                    <th>Küçük Enj Maliyeti Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.smallCostRate ? this.state.smallCostRate : "-"}
                    </td>
                   
                  </tr>

                  <tr>
                    <th>Büyük Enj Maliyeti Birimi (€)</th>
                    <td colSpan="4">
                      {this.state.bigCostRate ? this.state.bigCostRate : "-"}
                    </td>
                  </tr>

                
                  <tr>
                    <th>8x16 Lama Birimi</th>
                    <td colSpan="4">
                      {this.state.lama810Rate !== 0 ? this.state.lama810Rate : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>İşçilik Yüzdesi (%)</th>
                    <td colSpan="4">
                      {this.state.profitRate !== 0 ? this.state.profitRate : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Nakliye Birimi</th>
                    <td colSpan="4">
                      {this.state.transportRate !== 0 ? this.state.transportRate : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default FixedTpuDetail;
